import { useFacilities } from "@/hooks/useFacilities";
import { useFacility } from "@/hooks/useFacility";

/**
 * Hook to determine if a facility is an annex location
 * A facility is considered an annex if:
 * 1. There are multiple facilities in the context
 * 2. The facility has a main_facility value (indicating it's an annex of another facility)
 */
export const useIsAnnexFacility = (facilityId: number) => {
    const { facilities } = useFacilities();
    const { facility } = useFacility(facilityId);

    // Only check for annex when there are multiple facilities
    const hasMultipleFacilities = facilities.length > 1;

    // A facility is an annex if it has a main_facility value
    const isAnnex = hasMultipleFacilities && facility?.main_facility !== null;

    return {
        isAnnex,
        mainFacilityId: facility?.main_facility,
    };
};

